module.exports = __webpack_public_path__ + "static/media/bvp.8ef2eb54.png";